/** Finite known roster; failures are memoized too, avoiding per-frame retries. */
export function createAssetLoader({ ids, revision, load, timeoutMs = 30000 }) {
  const allowed = new Set(ids);
  const requests = new Map();
  const states = new Map();
  const values = new Map();
  return {
    request(id) {
      if (!allowed.has(id)) return Promise.resolve(null);
      if (requests.has(id)) return requests.get(id);
      states.set(id, 'loading');
      const request = new Promise(resolve => {
        let settled = false;
        const finish = (value, state) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          states.set(id, state);
          if (value) values.set(id, value);
          resolve(value);
        };
        const timer = setTimeout(() => finish(null, 'timeout'), timeoutMs);
        Promise.resolve().then(() => load(`/characters/${id}_all.glb?v=${encodeURIComponent(revision)}`))
          .then(value => finish(value, 'ready'), () => finish(null, 'failed'));
      });
      requests.set(id, request);
      return request;
    },
    get: id => values.get(id),
    has: id => values.has(id),
    status: () => Object.fromEntries(states),
  };
}
